<template>
  <div>
    <div class="agreement_main">
      <div class="text">欢迎申请使用百运公司（下列统称为“甲方”）提供的产品和服务。请您（下列统称为“物流商”或“乙方”）仔细阅读、充分理解以下全部内容，其中限制或免除责任的条款，以及其他涉及用户重大权益的条款（如违约处罚、争议管辖等）将会以加粗形式提示用户重点注意。本协议自您勾选“我已阅读并同意《百运物流平台合作协议》选项"后生效。</div>
      <div class="text">百运与物流商在本协议中称为“一方”或合称为“双方”。</div>
      <div class="text">鉴于：</div>
      <div class="text">1、通过百运开发、运营的物流服务信息系统向平台用户提供合理优化的物流解决方案以及物流信息管理服务，并与优质的物流服务商合作为平台用户提供具体的物流服务；</div>
      <div class="text">2、物流商具有履行物流服务国家或地区法律所要求的相关证书和资质以及提供国际物流服务以及其他与物流相关的增值服务资源，有能力提供《百运物流平台合作协议》下约定的国际物流服务；</div>
      <div class="text">3、物流商希望作为百运的供应商与百运合作，向接受平台用户委托的百运提供国际物流服务；</div>
      <div>
        <div class="title">一、定义与解释</div>
        <div class="text">1、“百运”：甲方及其旗下子公司、分公司、分支机构或相关关联公司统称为“百运”，本协议中提及的应由甲方或“百运”行使的权利和履行的义务，由“百运”内部负责相应区域及业务范围的公司分别履行。本协议由深圳市百运科技有限公司与乙方签署。</div>
        <div class="text">2、“百运网”指由百运提供互联网信息服务及相关的软件、技术支持的电子商务平台网站，网址为by56.com。<br>
          平台用户：指“百运网”用户，即所有在“百运网”上注册成为“百运网”注册会员的法人、自然人及其他组织，可以通过平台进行下单的用户。本协议中统称为“用户”，除非另有说明，否则“用户”均指此含义</div>
        <div class="text">3、“招商标准”指商户使用百运网服务须满足的前提标准，如提交证明文件或其他相关证明，包括但不限于营业执照、税务登记证、授权委托书、商标注册证等。</div>
        <div class="text">4、“招商标准”指商户使用百运网服务须满足的前提标准，如提交证明文件或其他相关证明，包括但不限于营业执照、税务登记证、授权委托书、商标注册证等。</div>
        <div class="text">5、“商户入驻”:指物流商完成商户注册，通过资质审核条件后成为百运网第三方经营者的过程；本协议中的物流商指本协议缔约方中的“乙方”。 商户确认本协议即表示商户向百运网承诺其已符合百运网招商标准并且在今后的服务使用过程中将一直符合百运网招商标准。百运网有权不时修订招商标准，并不时对商户的符合情况进行检查。</div>
        <div class="text">6、“商户”：指物流商完成商户注册，通过资质审核条件后成为百运网第三方经营者。</div>
        <div class="text">7、“百运网账户”指商户经百运网审核通过的具有独立且唯一性 “身份标识号码”，又称“百运网用户名”。商户在使用百运网服务的过程中，必须使用百运网账户配合其自设的密码登录.账户密码由商户自行保管。商户应妥善保管其百运网服务账户及密码信息，未经百运网同意，不得向他人转让或授权他人使用。通过百运网账户完成的操作、行为或承诺均视为商户本人行为或已获得商户充分的授权。</div>
        <div class="text">8、百运网规则：指标示在百运网之上的，与商户经营有关的任何规范性文件，包括但不限于商户手册、商户后台公告、商户后台帮助中心等。</div>
        <div class="text">9、“服务开通”指商户登陆百运网账户并完成信息提交、协议签署、费用缴纳（若有）后，经审核通过，百运网允许商户于百运网开设供应商账户、使用百运网服务进行经营的过程。</div>
        <div class="text">10、“互联网信息服务”系百运网服务之一，指由甲方向商户提供的、在百运网平台上为商户展示商品信息的服务。</div>
        <div class="text">11、“与互联网信息服务相关的软件技术服务” 系百运网服务之一，指由甲方向商户提供的、与信息展示、互联网交易相关的软件技术服务。</div>
        <div class="text">12、“其他服务”指百运网已向商户提供的其他信息服务或软件技术服务，具体服务项目以协议方在补充协议中的约定为准。</div>
        <div class="text">13、“《商务合同》”指双方对运输标准和质量做出要求等相关运输事项进行补充约定的相关协议。</div>
      </div>
      <div>
        <div class="title">二、双方权利义务</div>
        <div class="text">(1) 甲方负责运营推广百运网、提升销售转化率、营销策划和结算等工作，乙方负责在“百运网”开设的商户的运营及相关事务，主要包括供应商招商、库存、物流和售后服务等各个环节。</div>
        <div class="text">(2) 双方同意由甲方给用户提供完善便利的支付渠道，用户可以通过向甲方所经营的“百运网by56.com和m.by56.com” 网站下单，选择乙方在“百运网”上发布的运输服务产品并支付交易款。</div>
        <div class="text">(3) 甲方在收到顾客支付的款项后，通过甲方提供的后台接口即时将完整的销售订单传送给乙方，由乙方将完成销售订单所约定的商品交付。</div>
        <div class="title">1、百运权利及义务</div>
        <div class="text">(1) 百运及其关联公司有权对物流商提供的国际物流服务不时制定或更新相应规则、标准、流程等（包括但不限于服务标准、投诉赔付流程和规则）（以下统称“百运规则”），百运应尽所有合理方式告知物流商（包括但不限于通过百运系统、弹窗等在线告知方式），物流商知晓并同意严格遵守百运规则是与百运合作并为用户提供的基础及根本，若物流商不同意修改或更新后的百运规则，则物流商应在收到通知后1个工作日内书面告知百运并进行协商。</div>
        <div class="text">(2) 百运有权根据《商务合同》中约定应当提供的国际物流服务制订、发布业务操作规范、规则、关键业务考核指标等服务要求，并对物流商提供的国际物流服务进行定期考核与实时监督。</div>
        <div class="text">(3) 百运有权根据其业务需求引入其他合作方提供国际物流服务。</div>
        <div class="title">2、物流商权利及义务</div>
        <div class="text">(1) 物流商应在收到百运系统的指令后及时响应提供相应服务，并按百运的要求及时回传和更新订单处理信息和国际物流服务信息，并保证上述信息的准确性、及时性及完整性。</div>
        <div class="text">(2) 物流商有权在获得百运事先书面同意的前提下将本协议和《商务合同》项下的部分国际物流服务分包给有资质的物流服务商（以下简称“分包商”）。</div>
        <div class="text">(3) 物流商应将提供国际物流服务的底单及相关文件至少保留一年，自物流商完成百运委托服务之日起算，且于协议终止后应继续保留一年。 </div>
        <div class="text">(4) 物流商的承诺与保证:</div>
        <div class="text"><span></span>1.物流商应当确保具备从事本协议项下业务的资质，如在履行协议过程中因各种原因导致资质丧失的，应当立即通知甲方并采取一切有效措施防止甲方损失扩大并最终赔偿甲方的一切损失（直接和间接）；</div>
        <div class="text"><span></span>2.物流商应根据其注册国家及国际物流服务涉及国家的法律法规的要求自行购买国际物流服务相关的包括包裹和人员保险在内的足额保险并且承担相应成本；</div>
        <div class="text"><span></span>3.物流商保证其对本协议和相关《商务合同》的履行不会违反对任何一方有约束力的任何合同条款、义务、法律、规章或法令（包括但不限于个人信息安全、海关、反垄断、反洗钱和反盗版等法律），且物流商对百运保证其遵守可适用到服务项下包裹或交易的任何法律法规</div>
        <div class="text"><span></span>4.物流商承诺并保证，其提供物流服务过程中可触达的所有“地点”（无论作为国家或地区），都未以任何形式受到全部或部分禁运或限制，并且必须经过充分验证且得以严格遵守。前述地点包括但不限于：始发地，装载地，中转地点，转运时的到达地和最终目的地；</div>
        <div class="text"><span></span>5.物流商承诺遵守所有适用的进出口管制有关的法律法规，并取得履行本协议及具体《商务合同》的一切有关进出口管制的许可。</div>
        <div class="text">(5) 物流商应：</div>
        <div class="text"><span></span>1.遵守与反贿赂及反腐败相关的所有适用法律、法规和百运不时向物流商提供的道德政策及反贿赂政策；</div>
        <div class="text"><span></span>2.物流商陈述并保证物流商拥有提供具体物流服务所需的技能、专业知识，且合法拥有或可合法使用为双方合作之目的所需的设施设备，有能力提供熟练和充分、符合行业标准的服务；</div>
        <div class="text"><span></span>3.物流商应保存与根据本协议执行的或本协议预期的活动有关的所有文件，包括但不限于 采购订单、发票和收据，以及装箱单、材料清单、原产地证书、付款记录、买卖双方库存记录、运输记录和舱单、提单（例如，空运/船舶/卡车运输）、进出口记录 。</div>
        <div class="text"><span></span>4.物流商须遵守所有适用的法律法规，包括但不限于物流商或者百运开展经营的相关司法辖区的进口法规和劳动法、《1930年强迫劳动公约》、《1957年废除强迫劳动公约》以及国际劳工组织的其他相关公约。物流商不得使用任何定罪劳工或/和强迫劳工，也不得</div>
        <div class="text">(6) 乙方的进一步承诺：</div>
        <div class="text"><span></span>1.乙方在此无条件且不可撤销地承诺，除甲方已书面公布的规则/信息等内容外，乙方将不对任何第三方解释或说明任何非甲方书面公布的且与本协议和相关《商务合同》有关的信息，更不得对第三方作出任何明示或暗示的承诺和保证，包括但不限于双方履行本协议和相关《商务合同》的能力和任何活动规则等。为避免异议，乙方仅能按照甲方已公布的规则/信息本身向商家等第三方进行解释，而不得扩大化解释、过度引申及演绎，亦不得自行判定任何规则的范围和适用性等，更不得通过承诺低价、时效或其他优惠等任何方式招揽甲方之商家以开展自身业务（无论实际是否得以开展）。</div>
        <div class="text"><span></span>2.若甲方确认乙方未能遵守乙方义务且乙方第一次违反的，乙方应向甲方支付人民币2万元作为违约金；若乙方第二次违反的，乙方应向甲方支付人民币4万元作为违约金；若乙方第三次违反的，乙方应向甲方支付人民币6万元作为违约金，以此递增。除违约金外，甲方有权在乙方第一次违反承诺后根据情况相应减少乙方的业务量甚至立即单方解除本协议和相关《商务合同》。</div>
      </div>
      <div>
        <div class="title">三、物流商资质证明要求</div>
        <div class="text">1、物流商及其分包商在本协议和相关《商务合同》下提供服务，必须向百运提交符合要求的资质证明等文件。如果上述文件发生任何变更，物流商应在变更发生之日起十五个工作日内书面通知百运并提供变更后的文件复印件（加盖公章）。如因该变更导致物流商或其合作伙伴丧失履约条件或资格时，百运有权立即终止本协议和相关《商务合同》。</div>
        <div class="text">2、物流商证明文件提交：</div>
        <div class="text">物流商欲在本协议和相关《商务合同》下提供服务，必须向百运提交加盖物流商公章或授权代表签字的如下文件：</div>
        <div class="text">(1) 物流商的公司注册证书及相关文件（根据物流商注册地法律而确定）；</div>
        <div class="text">(2) 物流商企业法人代表身份证或护照复印件、授权文件等；</div>
        <div class="text">(3) 物流商提供服务应具备的业务许可证明和其他资质证明；</div>
        <div class="text">(4) 其他百运认为需查验的信息，包括但不限于物流商对仓储场所的所有权或占有使用权证明（产权证或租赁合同，租赁期限应覆盖物流服务涵盖的有效期限）；</div>
        <div class="text">3、物流商保证向百运提供的全部证明文件真实、准确且在协议有效期间持续有效，如果因物流商及其分包商的资质证明瑕疵或缺失而导致的任何法律责任（包括但不限于行政处罚责任、经济赔偿责任），由物流商独立全部承担，如果该等事由给百运（包括但不限于其代表的用户、商家、物流商、代理人、职员）造成其他损失的，物流商仍应赔偿百运全部损失。</div>
      </div>
      <div>
        <div class="title">四、审查和评估</div>
        <div class="text">为确保物流商所提供服务符合本协议及《商务合同》中约定的服务标准，双方同意百运有权要求召开会议进行以下工作：</div>
        <div class="text">1、评估前一季度物流商的总体表现和具体分类服务表现；</div>
        <div class="text">2、评估物流商是否存在未能达到预期服务标准或其他服务中需要改进的事项；</div>
        <div class="text">3、审查改进计划实施后物流商的服务情况；</div>
        <div class="text">4、物流商按百运要求提供工作报告，工作报告的内容及要求应根据百运要求；</div>
        <div class="text">5、物流商按百运要求提供业务指标统计（如覆盖区域的能力，业务量，可能的业务机会等）；</div>
        <div class="text">6、物流商同意，应百运合理要求，随时提供其他跟本协议及《商务合同》有关的任何额外的业务信息或数据。 </div>
      </div>
      <div>
        <div class="title">五、保证金的缴纳及使用</div>
        <div class="text">1、保证金缴纳</div>
        <div class="text">商户在签署（书面盖章签署或在线接受）本协议后，应向甲方指定百运银行账户内缴纳 元人民币做为保证金。</div>
        <div class="text">甲方指定百运银行账户：</div>
        <div class="text">开 户 银行：</div>
        <div class="text">开 户 名称：</div>
        <div class="text">人民币账号：</div>
        <div class="text">2、保证金的使用</div>
        <div class="text">除保证金的冻结外，百运网还有权按以下方式就保证金的管理和使用发出指令：</div>
        <div class="text">1）除本协议另有规定外，百运网将在下述条件均成就后的十（10）个工作日内发出指令，解除对保证金的冻结：a.本协议已终止；.本协议已终止；</div>
        <div class="text">b.商户在协议终止后的连续三个月内没有未完结的交易，亦没有未处理完毕的任何投诉、处罚或纠纷（包括但不限于与百运网、消费者或其他第三方的争议或纠纷）。</div>
        <div class="text">2）百运网可在以下情况发生时，处置保证金：</div>
        <div class="text">a．在百运网平台进行的交易中，如商户违反国家法律法规、规章政策或违反其对买家的承诺，导致或可能导致买家权益受损的，商户同意百运网有完全的权利进行责任判定，且百运网可基于上述判定划扣保证金用于代商户向买家退还货款、支付违约金和/或赔偿款。/或赔偿款。</div>
        <div class="text">b．在百运网平台进行的交易中，如商户违反本协议、百运网规则，或根据本协议、规则的规定应当向买家退还货款、支付违约金和/或赔偿款的，商户同意百运网有完全的权利进行责任判定，且百运网可基于上述判定划扣保证金用于代商户向买家退还货款、支付违约金和/或赔偿款。/或赔偿款。/或赔偿款。</div>
        <div class="text">c.如商户违反国家法律法规、规章政策致使百运网权益受损（包括但不限于被行政处罚、被判决侵权、被媒体曝光、商誉受损等），百运网有权划扣保证金中的相应金额至百运网账户作为违约金和/或赔偿款。</div>
        <div class="text">d.如商户违反本协议、百运网规则，根据协议或规则应当向百运网支付违约金和/或赔偿款，百运网有权划扣保证金中的相应金额至百运网账户作为违约金和/或赔偿款。</div>
        <div class="text">e.如商户对百运网存在逾期未付的款项（无论是否基于本协议），百运网有权立即划扣保证金中的相应金额至百运网账户。</div>
        <div class="text">f.如商户违反其与百运网任何关联公司（以下统称“关联公司”）之间的协议约定造成了该关联公司的经济损失或应向其支付违约金，商户不可撤销地授权百运网可以基于关联公司的要求将保证金中的相应金额全部或部分予以冻结或直接划扣至关联公司账户。关联公司的具体范围由百运网对商户进行另行通知，商户同意百运网不就该冻结或划扣指令承担任何责任，与此相关的纠纷和争议由商户与前述关联公司自行解决。</div>
        <div class="text">3）百运网如根据本协议、相关规则指令划扣保证金向百运网、消费者或其他第三方进行支付，应以书面方式（包括但不限于电子邮件、站内信、传真等）通知商户。在向商户出具的书面通知中，百运网将说明划扣原因及划扣金额。</div>
        <div class="text">4）发生下述情形，导致百运网对外支付或赔偿的款项超过可支配的保证金余额（该等支付或赔偿包括实际已经发生的或可能发生的），则百运网有权要求将商户的款项直接冻结以备赔付或直接支付给百运网以补偿百运网所遭受的损失：</div>
        <div class="text">1.商户申请破产或被申请破产；</div>
        <div class="text">2.商户因在百运网平台的经营行为导致其须对外承担远高于保证金余额的债务；</div>
        <div class="text">3.有证据表明商户的偿债能力明显下降或存在财产转移、套取百运网保证金的情形；</div>

      </div>
      <div>
        <div class="title">六、费用及结算</div>
        <div class="text">1、费用</div>
        <div class="text">买家通过百运网与乙方进行交易的，货款须支付至百运网指定甲方账户中。乙方应按照本协议及本协议附件《商户信息确认表》或补充协议（若有）中确定的标准及支付方式向百运支付下述费用：</div>
        <div class="text">1）技术服务费</div>
        <div class="text">a）乙方通过百运网完成的每一单交易应按照本协议及本协议附件《商户信息确认表》或补充协议（若有）的约定向百运支付技术服务费；</div>
        <div class="text">b）乙方在百运网的交易额以百运网记录的数据为准；</div>
        <div class="text">c）技术服务费由百运通过系统自买家交付的货款中扣除；</div>
        <div class="text">2）其他费用</div>
        <div class="text">a）乙方应向百运支付的其他费用，按照本协议或本协议附件或补充协议（若有）的约定收取。</div>
        <div class="text">b）经双方一致同意，甲方百运网所对应的技术服务费费率见本协议附件《商户信息确认表》及相关补充协议（若有）；特殊情况如促销，可双方另行协商。</div>
        <div class="text">2、结算</div>
        <div class="text">以订单中每一笔确认收入的费用项生成时间顺延“7天监督仲裁”所有需要的7个自然日后，百运网平台自动将此费用项的款项划拨于乙方在百运网的商户账户里，乙方可自行提现此笔资金。举例说明：用户采购了商户的快递渠道，用户把货发到商户的仓库里，商户完成货物入库操作并把计费重传送给百运网平台，百运网平台收到计费重后立即将此快递订单标记为已入库，并形成用户运费账单，用户向百运网预支付相应的运费，一段时间后商户安排货物出库并把出库信息推送给百运网，百运网收到出库信息立即将订单状态变更为“已出库”，记录该时间为T，同时生成商户的快递订单的第一笔账单，这个T时间即为商户订单的确认收入时间，那么商户可以在T+7天后提走这笔资金。</div>
        <div class="text">3）结算单由百运网平台自动生成，商户可登录到百运网账户里查阅此结算单，若有疑义，可在自确认收入时间开始计算的15个自然日之内向甲方客服提出结算单的核实请求，超出该要求的时间的对账请求，则双方同意以百运网生成的结算单作为最终对账单，甲方不再受理其它任何对账请求。</div>
        <div class="text">4）乙方在提现之前需向甲方开具等额的发票，具体发票类型以双方邮件为准. 甲方按此发票金额以银行转账方式向乙方支付相应款项。若发票不合法，甲方有权暂停支付。</div>
        <div class="text">甲方邮箱：finance@by56.com</div>
        <div class="text">6）如需修改以上信息需提前一个月书面形式通知甲方。如果乙方提供的信息不真实，不准确，不及时或不完全由此产生的一切问题由乙方自行承担。</div>

      </div>

      <div>
        <div class="title">七、物流商运输交付</div>
        <div class="text">1、定义</div>
        <div class="text">甲方在收到用户支付的预收款后，通过乙方提供的后台接口即时将完整的订单信息传送给乙方，乙方需根据订单信息完成货物的交付。</div>
        <div class="text">2、运输方式</div>
        <div class="text">1）原则上，乙方以严格按照用户订单要求的运输渠道进行履约，如果有变更，需经得甲方和百运网平台客户同意后方可调整。</div>
        <div class="text">2）乙方根据甲方提供的订单指示，将货物运输至甲方提供的用户订单指定的地址。</div>
        <div class="text">3、履约时限</div>
        <div class="text">乙方需确保在甲方提供的后台接口接收订单后，在订单要求的时效内将货物运输至甲方提供的用户订单指定的地址</div>

      </div>
      <div>
        <div class="title">八、知识产权</div>
        <div class="text">1、百运拥有与“百运”及“百运系统”平台相关的品牌、技术、专利、商业秘密等资产（包括但不仅限于包含在作品著作权、计算机程序源代码、任何标识、品牌、域名、数据、文档、资料，技术接口以及产品、客户信息、合作商信息、订单信息等）的知识产权和/或所有权，或该知识产权和/或所有权的授权使用权（以下简称“知识产权”），双方签署本协议和相关《商务合同》并不意味着百运转让上述知识产权，未经百运同意，物流商不得以任何理由自行或委托第三方以任何方式使用上述知识产权，否则百运有权提前30个自然日书面通知物流商单方面终止本协议和相关《商务合同》，并有权要求物流商根据本协议责任条款的约定赔偿全部损失（包括但不限于调查取证费用、公证费用、律师费等）。</div>
        <div class="text">2、双方同意并确认，百运和/或其关联公司非在履行本协议过程中产生的且以书面和/或非书面形式提供给物流商的任何资料、信息、内容、设计、数据及其相关的知识产权（包括但不限于商标权、服务标志、商号、字号、企业名称、版权、专利权、植物新品种权、集成电路布图设计等百运和/或其关联公司的智力劳动成果所享有的专有权）归属于百运和/或其关联公司（“甲方既有知识产权”），物流商不享有任何权利。</div>
        <div class="text">3、双方在履行本协议和相关《商务合同》过程中所产生的书面和/非书面形式的任何资料、信息、内容、设计、数据及其相关的知识产权均归百运所有，除为履行本协议和相关《商务合同》之目的，物流商不得以任何形式进行留存、复制、使用、许可他人。甲方有权就前述知识产权以甲方或其关联公司的名义办理知识产权的申请、注册、登记，乙方应当积极主动配合甲方。本条款不因本协议和相关《商务合同》终止或解除或其它条款被判定成为无效条款而成为无效条款。</div>
        <div class="text">4、在履行本协议过程中，物流商向百运提供的任何资料、信息、内容、设计、数据及其相关的知识产权，百运和/或其关联公司享有永久的、不可撤销的、无偿的使用权。自本协议生效之日起，物流商同意免费授予百运和/或其关联公司全球范围内普通许可使用物流商品牌、字号及标识，以便百运和/或其关联公司基于本协议之目的使用物流商品牌、字号及标识。本条款不因本协议终止或解除或本协议项下其它条款被判定成为无效条款而成为无效条款。</div>
        <div class="text">5、物流商同意并保证，物流商在履行本协议和相关《商务合同》过程中不侵犯任何第三方的知识产权，否则，物流商应承担因此而引起的一切法律责任。若甲方因此遭受诉讼、行政调查、禁令等，乙方应当最大合理努力协助甲方采取有效救济措施；若因此给甲方造成损失的，乙方应当承担赔偿责任并尽最大合理努力消除给甲方造成的负面影响。若因此导致物流商履行本协议过程中存在迟延、不完整、瑕疵等情形的，百运有权单方解除本协议，无需另行通知物流商。</div>
        <div class="text">6、物流商同意并保证，物流商和/或其关联公司不得利用任何手段修改、复制、发行、出租、汇编、发表百运和/或其关联公司的知识产权，不得通过反向工程等类似手段侵犯百运和/或其关联公司的知识产权，不得通过有线或无线方式向公众提供百运和/或其关联公司的知识产权。若乙方违反本条款，甲方有权单方解除本协议，无需另行通知乙方。若因此给甲方造成损失的，乙方应当承担赔偿责任。本条款不因本协议终止或解除或本协议项下其它条款被判定成为无效条款而成为无效条款。</div>
        <div class="text">7、物流商授权百运在百运系统及百运、百运关联公司及相关合作方网站上使用物流商的名称、商标、标识、服务品牌等，推广渠道宣传双方之间的合作以及物流服务，包括但不限于物流商承诺给予百运的服务标准、收费标准及其他物流服务有关信息。</div>
      </div>
      <div>
        <div class="title">九、保密及数据安全</div>
        <div class="text">1、除法律另有规定外，双方应确保在未经另一方书面授权的前提下，不对外披露另一方的保密信息</div>
        <div class="text">2、本条下所述“保密信息”指（1）物流商根据其与百运之间订立的包括但不限于本协议及其任何补充协议、任何《商务合同》及其任何补充协议及履行上述协议下义务时知晓或接收的百运技术、技术成果、价格及经营信息、技术信息以及用户相关数据信息（包括但不限于用户的姓名、买家购物信息、地址、联络方式，商家的任何信息（如货品库存、报关价格和收发货数据等）等）及积累的其他数据信息，无论上述信息以何种方式、通过何种载体提供给物流商。上述信息均属于百运的保密信息；（2）物流商明确书面告知百运该信息属于物流商保密信息的信息。</div>
        <div class="text">3、物流商对百运的保密信息应承担保密的义务，但为妥善实施本协议和相关《商务合同》规定的事项在必要的范围内向律师、会计师及政府机关披露的以及被政府机关要求披露的除外。因物流商或其代理、雇员的责任造成保密信息泄漏，物流商应承担违约责任并赔偿因此给百运造成的损失。</div>
        <div class="text">4、未经百运书面同意，物流商不得擅自泄露、复制、保存或将保密信息用于与本协议和相关《商务合同》无关的活动或利用上述保密信息谋利。</div>
        <div class="text">5、物流商及其分包商有权在经过百运事先同意后在其网站及各推广渠道中宣传和百运的合作。</div>
        <div class="text">6、本条所述的保密信息不包括双方可以通过书面证据证明的以下信息：</div>
        <div class="text"><span></span>（1）该信息在披露之时已成为可以公开获得的信息；</div>
        <div class="text"><span></span>（2）该信息是一方披露前已为另一方拥有的信息；</div>
        <div class="text"><span></span>（3）该信息是一方依据法律、法规、生效的司法判决或行政裁决必须披露的；</div>
        <div class="text"><span></span>（4）一方可从另一方以外的第三方合法获得的且无披露或使用限制的信息。</div>
        <div class="text">7、物流商承诺并保证，将对百运通过数据接口传输至物流商的买、卖家数据（“百运及其客户敏感数据”），包括但不限于买、卖家数据、交易订单数据、商品信息数据等采取合理必要的保护措施。百运及其客户敏感数据仅用于提供本协议和相关《商务合同》下的服务，物流商不应向直接提供本协议和相关《商务合同》下服务的服务商外的任何第三方传输或允许其访问。物流商应保证其使用的提供本协议和相关《商务合同》下服务的服务商负有不低于本协议程度的保密及数据安全义务。如为本协议和相关《商务合同》之目的，物流商需要向非上述服务商的第三方披露，或将百运及其客户敏感数据用于其他目的，包括但不限于其他服务、调研、市场营销等，需提前取得百运的书面许可。</div>
        <div class="text">8、物流商承诺并保证，将对用户数据实施适当的技术和组织措施，以免数据：(i)遭受意外或非法破坏；以及（ii）丢失、更改、受到未经授权的披露或访问（“安全事件”）。该等措施不仅要考虑现有技术水平、实施成本、以及数据处理的性质、范围、背景和目的，而且要考虑自然人因享有不同种类及程度的权利和自由所带来的风险。</div>
        <div class="text">9、双方承诺在本协议和相关《商务合同》终止（不论终止原因）之后仍然继续承担在此条款下的保密及数据安全义务。本协议和相关《商务合同》终止后，如披露方要求，接收方应当立即归还和/或销毁此等秘密信息及其全部副本；若由接收方销毁的，接收方应向披露方提供相关书面证明和/或确认。 </div>

      </div>
      <div>
        <div class="title">十、违约责任</div>
        <div class="text">1、物流商应保证其开具的收据或发票符合服务所在地法律且可以作为有效的财务凭证。否则，百运有权立即终止协议，并不承担任何因此导致的物流商的任何成本、损失或损害。物流商应承担在此情况下百运所遭受的直接损失。</div>
        <div class="text">2、物流商不得向百运及其关联企业之员工、顾问提供任何形式的不正当利益，如有，则物流商同意百运有权立即解除本协议和相关《商务合同》，并由物流商按(1)本协议和相关《商务合同》在解除当日已发生协议总价款的10％；或(2)提供相当任何形式的不正当利益的总金额，两者中较高的一项向百运支付违约金。若该违约金不足以补偿百运因物流商上述违约行为而遭受的直接经济损失，包括但不限于百运因此承担的赔偿金、罚金、违约金、寻找第三方物流商产生的额外费用及支出的合理法律费用等，物流商应向百运赔偿上述损失的余额部分。</div>
        <div class="text">3、若物流商违反本协议下义务的，则应向百运承担因此造成百运的所有损失，包括但不限于百运因此遭受的经济利益损失（包括直接损失与间接损失）及支出的合理法律费用等；甲方有权要求乙方直接出面解决上述诉讼与非诉纠纷，并且有权要求乙方向行政部门直接交纳罚款、承担因此甲方支出的诉讼费、律师费、交通费、保全费、公告费以及甲方向第三方（权利人或顾客）支付的赔偿费及其它一切合理支出。在此情况下百运有权立即解除本协议和相关《商务合同》。 </div>
        <div class="text">4、由于物流商的故意或过失导致用户信息泄露的，百运有权要求物流商每次泄露事件支付发生当月的总结算金额的1%或者人民币10万（二者取其高者）作为违约金。</div>
        <div class="text">5、物流商因违反本协议和相关《商务合同》约定需要向百运承担赔偿责任，百运有权从根据本协议或以本协议为基础双方签订的《商务合同》中物流商支付的保证金或百运应向物流商支付的服务费中扣除物流商的违约赔偿金。</div>
      </div>
      <div>
        <div class="title">十一、协议期限与终止</div>
        <div class="text">1、本协议经双方签字或盖章后成立，于 年 月 日生效。除发生本协议约定和/或法定之协议终止条件，本协议持续有效。</div>
        <div class="text">因故提前终止：任何一方有以下情況之一的，另一方有权以书面通知方式立即单方面提前终止本协议:</div>
        <div class="text"><span></span>（1）若由于物流商与分包商协议出现的违约、协议提前终止等情况导致物流商无法按约履行本协议，则物流商应在发生该违约情况后及时通知百运，由百运决定是否提前终止合作，但物流商仍根据本协议及双方签署的《商务合同》就违约行为承担赔偿责任;</div>
        <div class="text"><span></span>（2）物流商发生其它重大违约行为且在百运书面通知的合理期限內仍未纠正；</div>
        <div class="text"><span></span>（3）物流商实施其它有损于百运或用户的行为，且在百运通知的指定期限内未能纠正的；</div>
        <div class="text"><span></span>（4）一方进入任何自愿破产、破产、接管、清算或债务重整程序或类似程序的; </div>
        <div class="text"><span></span>（5）一方依法进入任何非自愿破产、破产、接管、清算或债务重整程序或类似程序，且在程序申请方向法院提交程序申请文件后的30天内未能撤销该程序的；</div>
        <div class="text"><span></span>（6）其他本协议、《商务合同》及其附件约定的情况。</div>
        <div class="text">3、无理由提前终止：百运提前30个自然日向物流商发出书面通知，可随时提前解除本协议。</div>
        <div class="text">4、协议终止后，事项处理：</div>
        <div class="text"><span></span>（1）物流商应配合百运完成相关的交接工作。物流商应按照百运的要求向百运提供物流商系统内与百运或本协议履行有关的数据、信息等资料，并保证相关资料从物流商服务器彻底删除，如发现信息泄露，百运保留向物流商追索的权利；</div>
        <div class="text"><span></span>（2）物流商同意百运关闭系统接口，停止对物流商提供订单和交接包裹；</div>
        <div class="text"><span></span>（3）除另有约定外，如本协议终止或解除（无论终止/解除原因）时，物流商仍有尚未办理完结的相关委托，物流商仍应根据本协议、商业惯例及诚实信用原则继续履行相关义务。如物流商应按本协议要求继续配送和处理在本协议终止前已接收的包裹，如出现延迟、丢失、破损和拒收等异常时，百运有权按本协议的约定要求物流商赔付；</div>
        <div class="text"><span></span>（4）物流商应配合百运进行费用对账。对于未结给物流商的费用，百运在扣除违约金、赔付费用，对账清算完毕且收到合法有效的发票后按照各《商务合同》和/或双方另行书面约定支付流程及周期支付给物流商。 </div>
      </div>
      <div>
        <div class="title">十二、不可抗力</div>
        <div class="text">(1) 不论在何种情况下，双方均不对由于不可抗力事件，如战争，罢工，暴乱，起义，恐怖袭击，骚乱，自然灾害（包括但不限于火灾，洪水，台风，火山爆发，地震，海啸），非因物流商原因造成的爆炸，政府行为（包括海关行为），国际、国内法院的命令而造成的不能提供服务或延迟提供服务承担责任，但物流商应在获悉相关信息或通知的情况的24小时内书面告知百运，以便百运在相关平台上进行公告。物流商应在百运要求的时间内提供相应的公文或政府文件；物流商若无法提供公文或政府文件即无法以此不可抗力为原因免责。</div>
        <div class="text">(2) 如上述不可抗力情形导致任何一方不能执行本协议和相关《商务合同》中的部分或全部义务时，应及时通知对方，对方可根据实际情况部分或全部免除其应承担的不能履行义务的责任。如不可抗力持续超过15个自然日，双方均可以提前书面通知对方解除本协议和相关《商务合同》。 </div>
      </div>
      <div>
        <div class="title">十三、争议解决</div>
        <div class="text">本协议适用中华人民共和国法律，凡因本协议引起的或与本协议有关的任何争议，均应向甲方所在地人民法院提起诉讼。</div>
      </div>
      <div>
        <div class="title">十四、联系</div>
        <div class="text">双方将各自的具体操作业务、财务人员名单，公司电话，传真，地址联系办法告知对方，便于加强联系。如有变动，应及时转告。</div>
        <div class="text">鉴于乙方承办货物的运输，本协议合同履行地为甲方工商登记注册地。</div>
      </div>
      <div>
        <div class="title">十五、其他</div>
        <div class="text">1、本协议及报价单构成甲、乙双方关于本协议事项之唯一合同，替代双方之前所达成之口头约定或任何形式之书面约定、协议、合同、合约、备忘录等相关文件。</div>
        <div class="text">2、以上为双方基于诚信，并充分了解协议、补充协议《商务合同》（如有）及其附件内容之效力后所订定，双方一致同意本协议其补充协议《商务合同》（如有）和附件与本协议具有相同法律效力。</div>
        <div class="text">3、本协议有效期为______年。有效期为______年____月____日至______年____月____日</div>
        <div class="text">4、以线上方式签订的，本协议自乙方勾选“我已阅读并同意《百运物流平台合作协议》选项"后生效。</div>
        <div class="text">如用户对本服务条款内容有任何疑问，可联系客服进行咨询（联系方式400 926 8156）</div>
      </div>
      <div>
        <div class="title">附件一 商户信息确认表</div>
        <table>
          <tr>
            <div style="width:20%;">企业名称</div>
            <div style="width:80%;"></div>
          </tr>
          <tr>
            <div style="width:20%;">企业地址</div>
            <div style="width:80%;"></div>
          </tr>
          <tr>
            <div style="width:20%;">企业工商注册号</div>
            <div style="width:80%;"></div>
          </tr>
          <tr>

            <div style="width:20%;">百运网商户注册号</div>
            <div style="width:80%;"></div>
          </tr>
          <tr>
            <div style="width:20%;">履约保证金(RMB)</div>
            <div style="width:80%;"></div>
          </tr>
          <tr>
            <div style="width:50%;background:gray">法人代表信息</div>
            <div style="width:50%;background:gray">接口人信息</div>
          </tr>
          <tr style="display:flex;justify-content: center;align-items:center">
            <div style="width:20%;">姓名</div>
            <div style="width:20%;">身份证号</div>
            <div style="width:20%;">姓名</div>
            <div style="width:20%;">电话</div>
            <div style="width:20%;">Email</div>
          </tr>
          <tr>
            <div style="width:20%;"></div>
            <div style="width:20%;"></div>
            <div style="width:20%;"></div>
            <div style="width:20%;"></div>
            <div style="width:20%;"></div>
          </tr>
          <tr>
            <div style="width:20%;"></div>
            <div style="width:20%;"></div>
            <div style="width:20%;"></div>
            <div style="width:20%;"></div>
            <div style="width:20%;"></div>
          </tr>
          <tr>
            主要经营的商品
          </tr>
          <tr>
            <div style="width:20%;">商品名</div>
            <div style="width:20%;">主要功能</div>
            <div style="width:20%;">一级品类SKU</div>
            <div style="width:20%;">佣金率</div>
            <div style="width:20%;">备注</div>
          </tr>
          <tr>
            <div style="width:20%;"></div>
            <div style="width:20%;"></div>
            <div style="width:20%;"></div>
            <div style="width:20%;"></div>
            <div style="width:20%;"></div>
          </tr>
          <tr>
            <div style="width:20%;"></div>
            <div style="width:20%;"></div>
            <div style="width:20%;"></div>
            <div style="width:20%;"></div>
            <div style="width:20%;"></div>
          </tr>
          <tr>
            <div style="width:20%;"></div>
            <div style="width:20%;"></div>
            <div style="width:20%;"></div>
            <div style="width:20%;"></div>
            <div style="width:20%;"></div>
          </tr>
        </table>
      </div>
    </div>
    <div class="agree">
      <button @click="agree">同意并继续</button>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {

    }
  },
  methods: {
    agree() {
      this.$emit('agreeAgreement', false)
    }
  },
}
</script>
<style lang="scss" scoped>
.agreement_main {
  height: 368px;
  overflow: auto;
}
.agreement_main::-webkit-scrollbar {
  /* 定义滚动条样式 */
  width: 4px;
}
.agreement_main::-webkit-scrollbar-track {
  /*定义滚动条轨道 内阴影+圆角*/
  box-shadow: inset 0 0 0px #dddddd;
  border-radius: 2px;
}
.agreement_main::-webkit-scrollbar-thumb {
  /*定义滑块 内阴影+圆角*/
  border-radius: 10px;
  box-shadow: inset 0 0 0px rgba(240, 240, 240, 0.5);
  background-color: #dddddd;
}
.agreement_person {
  display: flex;
  margin: 4px 0 4px;
  > div {
    width: 50%;
    div {
      font-size: 14px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #333333;
      line-height: 24px;
    }
  }
}
.text {
  margin-top: 8px;
  font-size: 13px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  line-height: 22px;
}
.title {
  height: 32px;
  line-height: 32px;
  margin: 16px 0 0;
  font-size: 14px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #333333;
}
table {
  border: solid 1px black;
  width: 100%;
  display: block;
}
tr {
  width: 100%;
  border: solid 1px black;
  height: 32px;
  font-size: 13px;
  color: black;
  display: flex;
  justify-content: center;
  align-items: center;
  div {
    height: 100%;
    display: flex;
    border-right: solid 1px black;
    justify-content: center;
    align-items: center;
  }
}
td {
  border: solid 1px black;
  text-align: center;
  width: 20%;
}
h3 {
  margin: 0;
  font-size: 14px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #333333;
  line-height: 24px;
}
.agree {
  padding-top: 24px;
  display: flex;
  flex-direction: row-reverse;
  button {
    width: 96px;
    outline: none;
    height: 32px;
    cursor: pointer;
    background: #0046b9;
    border-radius: 4px;
    border: 1px solid #0046b9;
    transition: background 0.2s;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffffff;
    &:hover {
      background: #2963c4;
      border: 1px solid rgba(0, 70, 185, 0);
      transition: background 0.2s;
    }
    &:active {
      background: #003a9b;
      border: 1px solid rgba(0, 70, 185, 0);
      transition: background 0.2s;
    }
  }
}
</style>